import {useGetDocument360RedirectUrlQuery} from '@dms/api/security';
import i18n from '@dms/i18n';
import {useTenant} from '@dms/shared';

import {TestIdProps, suffixTestId} from 'shared/web';

import {omneticReleaseNotes} from '../../../releaseNotes';
import {TopBarMenuItem} from './TopBarMenuItem';

const LATEST_RELEASE_NOTE = omneticReleaseNotes[0];

interface ReleaseItemProps extends TestIdProps {}

export function LatestReleaseLink(props: ReleaseItemProps) {
  const {tenantCountry} = useTenant();
  const releaseUrl = LATEST_RELEASE_NOTE.urlByCountry?.[tenantCountry] ?? LATEST_RELEASE_NOTE.url;

  const {data, isLoading} = useGetDocument360RedirectUrlQuery({
    redirectTo: releaseUrl,
  });

  return (
    <TopBarMenuItem
      to={data?.redirectUrl ?? ''}
      target="_blank"
      label={i18n.t('general.labels.releaseNotesTitle')}
      icon="action/grade"
      isLoading={isLoading}
      isDisabled={!data?.redirectUrl}
      data-testid={suffixTestId('release-link', props)}
    />
  );
}
